/** @param {{ fr?: string, en?: string } | string | undefined} value @param {'fr'|'en'} locale */
export function pickFormationText(value, locale = "fr") {
  if (!value) return "";
  if (typeof value === "string") return value;
  return value[locale] ?? value.fr ?? value.en ?? "";
}

/** @param {'NOT_STARTED'|'IN_PROGRESS'|'COMPLETED'} status @param {'fr'|'en'} locale */
export function formationStatusLabel(status, locale = "fr") {
  const map = {
    NOT_STARTED: { fr: "À commencer", en: "Not started" },
    IN_PROGRESS: { fr: "En cours", en: "In progress" },
    COMPLETED: { fr: "Terminé", en: "Completed" },
  };
  return map[status]?.[locale] ?? status;
}
